import React from 'react'
import UserGroup from '../../components/UserGroup/UserGroup'

const User_Group = () => {
	return (
		<div>
			<UserGroup />
		</div>
	)
}


export default User_Group